import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 10.8626L11 5.5293L19 10.8626",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 21.5293H19",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.66663 18.8626V13.5293",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.22217 18.8626V13.5293",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7778 18.8626V13.5293",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3334 18.8626V13.5293",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBankIcon;
